import { HealthCheck } from '../types/healthCheck';
import healthCheckConfig from '../config/healthCheck.config';

/**
 * Creates service health object from healthCheck config
 */
export function getDefaultServiceHealth() {
  return healthCheckConfig.servicesToCheck.reduce((obj: Record<string, boolean>, key: string) => {
    obj[key] = true;
    return obj;
  }, {}) as Record<HealthCheck.ServiceType, boolean>;
}

/**
 * Creates service failed count object from healthCheck config
 */
export function getDefaultServiceFailedCount() {
  return healthCheckConfig.servicesToCheck.reduce((obj: Record<string, number>, key: string) => {
    obj[key] = 0;
    return obj;
  }, {}) as Record<HealthCheck.ServiceType, 0>;
}
